/** Only use with an idempotent request whose identifier stays fixed across attempts. */
export async function retryRaceCallable<T>(call: () => Promise<T>, wait: (milliseconds: number) => Promise<void> =
  (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds))): Promise<T> {
  const delays = [1000, 2500];
  for (let attempt = 0; ; attempt += 1) {
    try { return await call(); }
    catch (error) {
      const code = (error as { code?: string })?.code;
      if (attempt >= delays.length || !["functions/internal", "functions/unavailable", "functions/deadline-exceeded"].includes(code || "")) throw error;
      await wait(delays[attempt]);
    }
  }
}
